// extracted by mini-css-extract-plugin
module.exports = {"line-reward-badge":"style_line-reward-badge__10JKD"};